<template>
  <transition
    :name="animation == 'slideup' ? 'slideup' : 'slide'"
    mode="out-in"
  >
    <div
      v-if="isOpen"
      class="slide-over-wrapper h-screen fixed z-50 top-0 right-0 overflow-y-auto"
      :class="{
        'w-full': width == 'full',
        'w-3/4': width == 'quarter-to',
        'w-1/2': width == 'half',
        'w-1/4': width == 'quarter',
        'w-auto': width == 'auto',
        'bg-white': bgColor == 'white',
        'bg-secondary-darker text-secondary-invert': bgColor == 'dark',
        'bg-grey': bgColor == 'grey',
        'slide-sidebar': type == 'sidebar',
      }"
    >
      <span class="cursor-pointer absolute close-icon" @click="emitCollapse()">
        <CloseIcon class="h-6 w-6"/>
      </span>
      <div class="w-full h-full py-5 px-4">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>

// import icons
import CloseIcon from '@/assets/images/icons/new/close_small_new.svg';

export default {
  name: 'SlideOver',
  components: { CloseIcon },

  props: {
    name: { required: true },
    width: { default: 'full' },
    bgColor: { default: 'white' },
    type: {},
    animation: { default: 'slide' },
  },

  data() {
    return { isOpen: false };
  },

  mounted() {
    this.$root.$on('expand-slider', (name) => {
      if (name === this.name) this.expand();
    });
    this.$root.$on('collapse-slider', (name) => {
      if (name === this.name) this.collapse();
    });
  },

  methods: {
    expand() {
      this.isOpen = true;
    },

    collapse() {
      this.isOpen = false;
    },

    emitCollapse() {
      this.$emit('collapse');
    },
  },
};
</script>

<style scoped>
.close-icon {
  left: 16px;
  top: 24px;
}

.bg-grey {
  background: #f7f7fa;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.8s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(100%) !important;
  transition: all 800ms ease-in 0s;
}
.slide-sidebar {
  width: 320px;
  padding: 0;
  height: calc(100vh - 75px);
  top: auto;
  bottom: 0;
}
.slide-sidebar > .w-full {
  padding: 0;
}
.slide-sidebar .close-icon {
  top: 24px;
}
.slideup-enter-active {
  animation: slide-up 0.4s;
}
.slideup-leave-active {
  animation: slide-up 0.4s reverse;
}
@keyframes slide-up {
  0% {
    top: 100%;
  }
  100% {
    top: 0;
  }
}
</style>
<style>
.slide-over-wrapper.shadow.overflow-y-auto {
  display: none !important;
}
</style>